import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import ProgressBar from '../progress.bar';
import { getFeatureToggle, getLoanApplication } from '../../selectors';
import moneyFormatter from 'money-formatter';
import PropTypes from 'prop-types';
import Section from '../Section/section';
import FullAppForm from "../LoanApplication/FullAppForm/fullAppForm";
import LoanApplicationHeader from '../LoanApplication/LoanApplicationHeader/loanApplicationHeader';
import { displayErrors } from '../../actions';

export class FullAppPage extends React.Component {

  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render = () => {
    const { loanAmount, firstName, selectedQuote } = this.props;


    if (!loanAmount || !firstName || !selectedQuote) {
      return <Redirect to="/apply" />;
    }

    return (
      <article>
        <LoanApplicationHeader title={`${firstName}'s loan details`} smallContent={true}>
          <ul className="d-flex flex-row justify-content-around">
            <li>
              <h2 id="loan-amount">{moneyFormatter.format('USD', loanAmount, 0)}</h2>
              <p>Requested amount</p>
            </li>
            <li>
              <h2 id="monthly-payment">{moneyFormatter.format('USD', selectedQuote.monthlyPayment.amount, 0)}</h2>
              <p>Monthly payment</p>
            </li>
            <li>
              <h2 id="loan-term">{selectedQuote.termInMonths} months</h2>
              <p>Loan term</p>
            </li>
            <li>
              <h2 id="apr">{selectedQuote.apr}%</h2>
              <p>APR</p>
            </li>
          </ul>
        </LoanApplicationHeader>
        <Section>
          <header>
            <ProgressBar step="fullApp"/>
            <p className="font-weight-normal">Almost there! Just complete and submit.</p>
          </header>
          <FullAppForm />
        </Section>
      </article>
    );
  }
}

FullAppPage.propTypes = {
  displayErrors: PropTypes.func.isRequired,
  loanAmount: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  selectedQuote: PropTypes.shape({
    apr: PropTypes.number.isRequired,
    termInMonths: PropTypes.number.isRequired,
    monthlyPayment: PropTypes.shape({
      amount: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};


const mapStateToProps = (state) => {
  const application = getLoanApplication(state);
  if(getFeatureToggle(state, "cl_update_disclosure_and_header_for_cyl_eligible")) {
    return {
      loanAmount: application.selectedQuote.loanAmount.amount,
      firstName: application.firstName,
      selectedQuote: application.selectedQuote
    };
  } else {
    return {
      loanAmount: application.loanAmount,
      firstName: application.firstName,
      selectedQuote: application.selectedQuote
    };
  }
};

const mapDispatchToProps = { displayErrors };

export default connect(mapStateToProps, mapDispatchToProps)(FullAppPage);


